import { useState } from "react";
import _debounce from "lodash/debounce";
import { IPagination } from "../interfaces/shared/IPagination";

interface IProps {
  perPage?: number;
  paginationKeys?: any;
}

export const usePagination = ({ perPage = 10, paginationKeys }: IProps) => {
  const [pagination, setPagination] = useState<IPagination | any>({
    page: 0,
    size: perPage,
    ...paginationKeys,
  });
  const [inputValue, setInputValue] = useState("");
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [count, setCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const handlePages = (updatePage: number) => {
    setPagination({ ...pagination, page: updatePage });
    setPage(updatePage);
  };

  const handleUpdateList = () => {
    setPagination((prev: IPagination) => ({
      ...prev,
      updatedAt: new Date()?.getTime(),
      page: 0,
    }));
  };

  const changeFilterHandler = _debounce(
    (name: string, value: string | null | number | boolean | number[]) => {
      setPagination((prev: IPagination) => ({
        ...prev,
        page: 0,
        [name]: value,
      }));
    },
    300,
  );

  return {
    pagination,
    page,
    setPage,
    totalPages,
    setTotalPages,
    setPagination,
    handlePages,
    changeFilterHandler,
    count,
    setCount,
    totalCount,
    setTotalCount,
    handleUpdateList,
    inputValue,
    setInputValue,
  };
};
